import React, { useContext, useEffect } from 'react'
import Layout from '../Layout'
import SlidePanel from '../../../Component/SlidePanel'

const ProductView = () => {
    return (
        <Layout>
            <div className="contact-main-container">
                <SlidePanel viewPage={true} enableZoomOnHover={true} />
            </div>
        </Layout>
    )
}

export default ProductView
